import React from "react";
import Dashboard from "components/dashboard";
import { PageSection, PageHeaderBar } from "components/page";
import { useMutation } from "@apollo/react-hooks";
import DataGrid from "components/data-grid";
import ValidatedForm from "components/form";
import { mutation, validationSchema, getDefaultValues, handleSubmit, NewCustomerForm } from "./forms/new-form";
import { useCurrentCustomerContext } from "components/current-customer-context";

const CustomerNewPage = ({ intl, history }) => {
  const [createCustomer] = useMutation(mutation);
  const { currentCustomerId } = useCurrentCustomerContext();

  return (
    <Dashboard>
      <PageHeaderBar title="app.page.customer.new" />
      <PageSection>
        <ValidatedForm
          initialValues={getDefaultValues()}
          validationSchema={validationSchema(intl)}
          onSubmit={handleSubmit({
            createCustomer,
            history,
            customerId: currentCustomerId,
          })}
        >
          {props => (
            <DataGrid>
              <NewCustomerForm {...props} />
            </DataGrid>
          )}
        </ValidatedForm>
      </PageSection>
    </Dashboard>
  );
};

export default CustomerNewPage;
